import { render, staticRenderFns } from "./ProjectTaskNewFormFrProject.vue?vue&type=template&id=33561c11&"
import script from "./ProjectTaskNewFormFrProject.vue?vue&type=script&lang=js&"
export * from "./ProjectTaskNewFormFrProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports